export default "__VITE_ASSET__Li22GLbK__"